var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 54C42.3594 54 54 42.3594 54 28C54 13.6406 42.3594 2 28 2C13.6406 2 2 13.6406 2 28C2 42.3594 13.6406 54 28 54Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2307 19.3846H20.1922C19.978 19.3846 19.7726 19.4697 19.6211 19.6212C19.4696 19.7727 19.3845 19.9781 19.3845 20.1923V36.3462C19.3845 36.5604 19.4696 36.7658 19.6211 36.9173C19.7726 37.0688 19.978 37.1539 20.1922 37.1539H24.2307C24.4449 37.1539 24.6503 37.0688 24.8018 36.9173C24.9533 36.7658 25.0384 36.5604 25.0384 36.3462V20.1923C25.0384 19.9781 24.9533 19.7727 24.8018 19.6212C24.6503 19.4697 24.4449 19.3846 24.2307 19.3846Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3462 19.3846H32.3077C32.0935 19.3846 31.888 19.4697 31.7366 19.6212C31.5851 19.7727 31.5 19.9781 31.5 20.1923V36.3462C31.5 36.5604 31.5851 36.7658 31.7366 36.9173C31.888 37.0688 32.0935 37.1539 32.3077 37.1539H36.3462C36.5604 37.1539 36.7658 37.0688 36.9173 36.9173C37.0687 36.7658 37.1538 36.5604 37.1538 36.3462V20.1923C37.1538 19.9781 37.0687 19.7727 36.9173 19.6212C36.7658 19.4697 36.5604 19.3846 36.3462 19.3846Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.d5a639a91cae901956799cfca0f2542c.svg";
export { ForwardRef as ReactComponent };